import { useRouter } from "next/router";
import { ArticleJsonLd } from "next-seo";
import React from "react";

import { getServerSideCurrentUrl } from "../src/utils/getServerSideCurrentUrl";

import { LayoutProps } from "./Default";

const JsonLd = (props: {
  updatedAt?: string;
  articleDate?: string;
  seoData: LayoutProps["seoData"];
  pageType: LayoutProps["pageType"];
  ogImageUrl: string;
}) => {
  const router = useRouter();
  const { seoData, pageType, ogImageUrl } = props;

  switch (pageType) {
    case "contentHubArticle":
      return (
        <ArticleJsonLd
          title={seoData.title}
          url={getServerSideCurrentUrl(router, "https://www.brex.com")}
          images={[ogImageUrl]}
          datePublished={props.articleDate || ""}
          dateModified={props.updatedAt}
          authorName={undefined}
          description={seoData.description}
        />
      );

    default:
      return null;
  }
};

export default JsonLd;
